import { parseSpotifyEntityId, parseSpotifySource, parseSpotifySource as parseSpotifySource$1 } from "@videojs/media";
import { serializeEmbedParams } from "@videojs/media/dom";
//#region src/source.ts
/**
* Build the iframe `src` URL for an initial Spotify embed from the given props.
*
* @internal
*/
function buildSpotifyIframeSrc(src, props = {}) {
	const parsed = parseSpotifySource(src);
	if (!parsed) return "";
	const { preferVideo, referrerPolicy: _referrerPolicy, ...spotify } = props.source?.engine?.spotify ?? {};
	const params = {
		t: parsed.startTime,
		...spotify
	};
	const videoPath = preferVideo ? "/video" : "";
	const query = serializeEmbedParams(params);
	return `${EMBED_BASE}/embed/${parsed.type}/${parsed.id}${videoPath}${query ? `?${query}` : ""}`;
}
const EMBED_BASE = "https://open.spotify.com";
//#endregion
export { buildSpotifyIframeSrc, parseSpotifyEntityId, parseSpotifySource$1 as parseSpotifySource };
